import { Copy, ExternalLink } from "lucide-react";
import { Link } from "@/lib/nav";
import { toast } from "sonner";

import { Button } from "@buildpy/ui/button";

interface Props {
  // 공개 페이지 절대 주소 — 조직 slug 로 만든다.
  url: string;
  publishedCount: number;
  // 조직 설정 `portfolio.public_page` — 끄면 주소가 404 라 보기·복사 대신 켜는 안내를 둔다.
  enabled: boolean;
}

// 시공사례 목록의 「공개 페이지 보기 · 주소 복사」 — 공개된 사례가 없으면 빈 페이지라는 안내를 붙인다.
const PublicPageLink = ({ url, publishedCount, enabled }: Props) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("공개 페이지 주소를 복사했습니다");
    } catch {
      toast.error("복사하지 못했습니다");
    }
  };

  if (!enabled) {
    return (
      <p className="text-xs text-muted-foreground" data-testid="portfolio-public-off">
        <Link className="underline underline-offset-2" href="/app/settings">
          설정에서 공개 페이지를 켜세요
        </Link>
      </p>
    );
  }

  return (
    <div className="flex flex-col items-end gap-y-1" data-testid="portfolio-public-link">
      <div className="flex items-center gap-x-2">
        <Button asChild size="sm" variant="outline">
          <a href={url} rel="noopener" target="_blank">
            <ExternalLink className="size-4" />
            공개 페이지 보기
          </a>
        </Button>
        <Button size="sm" type="button" variant="outline" onClick={copy}>
          <Copy className="size-4" />
          주소 복사
        </Button>
      </div>
      {publishedCount === 0 && (
        <p className="text-xs text-muted-foreground" data-testid="portfolio-public-empty">
          공개로 둔 사례가 없어 공개 페이지가 비어 있습니다
        </p>
      )}
    </div>
  );
};

export default PublicPageLink;
